'use client'
import React, {
  PropsWithChildren,
  useCallback,
  useLayoutEffect,
  useState,
} from 'react'

import { useTranslations } from 'next-intl'
import { LoadingWithContainer } from '../../Loaders'
import LoadMoreButton from '../../LoadMoreButton/loadMoreButton'
import { Body, Cell, Head, NoData, Row, Table } from '../Elements'
import styles from '../Elements/styles.module.scss'
import { IDataTable } from './types'
import { useBody } from './useBody'

interface DataTableProps {
  itemsPerPage?: number
  lazy?: boolean
  data: IDataTable
  loading?: boolean
}
const DataTable: React.FC<DataTableProps> = ({
  itemsPerPage = 5,
  lazy = true,
  data,
  loading,
}: PropsWithChildren<DataTableProps>) => {
  const [itemsInPage, setItemsInPage] = useState(5)
  const t = useTranslations('translation')

  const loadMoreClick = useCallback(() => {
    setItemsInPage(itemsInPage + itemsPerPage)
  }, [itemsInPage, itemsPerPage])

  useLayoutEffect(() => {
    setItemsInPage(itemsPerPage)
  }, [itemsPerPage])

  const body = useBody({
    lazy,
    columns: data.columns,
    itemsInPage,
    rows: data.rows,
  })

  if (loading !== undefined && loading) {
    return <LoadingWithContainer />
  }

  return (
    <div>
      {data.rows.length === 0 ? (
        <NoData>{t('noData')}</NoData>
      ) : (
        <Table>
          <Head>
            <Row>
              {data.columns.map(column => (
                <Cell key={column.field}>{column.label}</Cell>
              ))}
            </Row>
          </Head>
          <Body>{body}</Body>
        </Table>
      )}

      {lazy && data.rows.length > itemsInPage && (
        <div className={styles.loadMoreWrap}>
          <LoadMoreButton onClick={loadMoreClick}>
            {t('loadMore')}
          </LoadMoreButton>
        </div>
      )}
    </div>
  )
}

export default DataTable
